import { JetBrains_Mono, Spectral } from "next/font/google";

// Inter is supplied by the root layout; Spectral restores the editorial voice.
export const lpSerif = Spectral({
  weight: ["400", "500"],
  subsets: ["latin", "latin-ext"],
  display: "swap",
  variable: "--font-lp-serif",
});
export const lpMono = JetBrains_Mono({
  weight: ["400", "500"],
  subsets: ["latin", "latin-ext"],
  display: "swap",
  variable: "--font-lp-mono",
});
export const lpFontVars = `${lpSerif.variable} ${lpMono.variable}`;
